var RosterUploadProgressMeter = require("components/org/roster_upload/RosterUploadProgressMeter");
var RosterUploadButtons = require("components/org/roster_upload/RosterUploadButtons");
var StudentRoster = require("lib/data/StudentRoster");
var CurrentUser = require("lib/account/CurrentUser");

class RosterUploadConfirm extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var roster = this.props.roster;

		var rowCount = roster.rowCount();
		var studentCount = rowCount - roster.studentsMissingColumns().length;
		var gradeLevelCount = _.uniq(_.compact(roster.getColumn(StudentRoster.Columns.GRADE_LEVEL))).length;
		var classroomCount = _.uniq(_.compact(roster.getColumn(StudentRoster.Columns.CLASSROOM))).length;

		var parentEmailText = "No";
		if (roster.hasColumn(StudentRoster.Columns.PARENT_EMAIL)) {
			var count = _.select(roster.getColumn(StudentRoster.Columns.PARENT_EMAIL), function(email) {
				return email && $wr.isValidEmail(email);
			}).length;
			var parentEmailText = "Yes (" + count + ")";
		}

		var usernameText = "No";
		if (roster.hasColumn(StudentRoster.Columns.USERNAME)) {
			var count = _.select(roster.getColumn(StudentRoster.Columns.USERNAME), function(username) {
				return username && username.trim().length > 0;
			}).length;
			var usernameText = "Yes (" + count + ")";
		}

		var passwordText = "No";
		if (roster.hasColumn(StudentRoster.Columns.PASSWORD)) {
			var count = _.select(roster.getColumn(StudentRoster.Columns.PASSWORD), function(password) {
				return password && password.trim().length > 0;
			}).length;
			var passwordText = "Yes (" + count + ")";
		}

		if (CurrentUser.isSchoolAdmin()) {
			var teacherEmailText = "No";
			if (roster.hasColumn(StudentRoster.Columns.TEACHER_EMAIL)) {
				var teacherEmailText = "Yes";
			}

			var teacherEmails = (
				<tr>
					<th>Teacher Emails?</th><td>{ teacherEmailText }</td>
				</tr>
			)
		}

		return (
			<div className="uploadManager">
				<RosterUploadProgressMeter index={ 4 } />

				<p>
					Please look over the table below and then click 'Finish' if everything looks correct.
				</p>

				<RosterUploadButtons finalStage={ true }
					nextStage={ this.props.nextStage }
					confirmChanges={ this.confirmChanges } />

				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<table className="table table-striped table-bordered csvConfirmTable">
							<tbody>
								<tr>
									<th>Students</th><td>{ rowCount }</td>
								</tr>
								<tr>
									<th>Classrooms</th><td>{ classroomCount }</td>
								</tr>
								<tr>
									<th>Grades</th><td>{ gradeLevelCount }</td>
								</tr>
								{ teacherEmails }
								<tr>
									<th>Parent Emails?</th><td>{ parentEmailText }</td>
								</tr>
								<tr>
									<th>Custom Usernames?</th><td>{ usernameText }</td>
								</tr>
								<tr>
									<th>Custom Passwords?</th><td>{ passwordText }</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		)
	}
};

RosterUploadConfirm.propTypes = StrictPropTypes({
	nextStage: PropTypes.func.isRequired,
	updateRosterData: PropTypes.func.isRequired,

	// Instance of StudentRoster.js
	roster: PropTypes.object.isRequired
});

module.exports = RosterUploadConfirm;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadConfirm.js